<template>
    <AddPayoutWindow v-if="addPayoutWindowIsOpened" v-model:isOpened="addPayoutWindowIsOpened"/>
    <PayoutDetailWindow v-if="payoutDetailWindowIsOpened" v-model:isOpened="payoutDetailWindowIsOpened" :currentPayout="currentPayout"/>
    <PrintScheduleAndSalaryWindow v-if="printScheduleAndSalaryWindowIsOpened" @next="openScheduleAndSalaryDetailWindowIsOpened" v-model:addSignForm="addSignForm" v-model:isOpened="printScheduleAndSalaryWindowIsOpened"/>
    <ScheduleAndSalaryDetailWindow v-if="scheduleAndSalaryDetailWindowIsOpened" v-model:isOpened="scheduleAndSalaryDetailWindowIsOpened" :addSignForm="addSignForm"/>

    <section class="mx-8 px-8 py-6 mb-[1rem] bg-white rounded-md flex justify-between items-start">
        <div class="flex justify-between w-full">
            <div v-if="role == 'founder'" class="flex items-center gap-8">
                <button type="button" @click="goToStaffs" class="rounded-md ">Сотрудники</button>
                <button type="button" class="rounded-md bg-indigo-100 px-4 py-2">Графики и зарплаты</button>
            </div>
            <span v-else class="text-3xl">Графики и зарплаты</span>
            <div class="flex items-center gap-4">
                <button @click="openPrintScheduleAndSalaryWindow" type="button" class="relative border border-custom-blue hover:bg-gray-100 text-sm text-custom-blue py-2 rounded-md flex items-center font-medium px-5 whitespace-nowrap">
                    <svg class="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M480-322.87 268.52-534.35l63.89-65.41L434.5-497.44v-310.69h91v310.69l102.09-102.32 63.89 65.41L480-322.87Zm-237.13 171q-37.78 0-64.39-26.61t-26.61-64.39v-120h91v120h474.26v-120h91v120q0 37.78-26.61 64.39t-64.39 26.61H242.87Z"></path></svg>
                    <span>Выгрузка на печать</span>
                </button>
                <select v-model="currentKassa" :disabled="scheduleMode === 'edit'" class="rounded-md p-2 text-sm hover:bg-gray-100" :class="{'cursor-not-allowed': scheduleMode === 'edit', 'cursor-pointer': scheduleMode === 'show'}">
                    <option value="all">Все кассы</option>
                    <option v-for="kassa in kassas" :key="kassa.id" :value="kassa.id">{{ kassa.name }}</option>
                </select>
                <div class="flex align-items text-black min-w-48 h-[2.375rem]">
                    <button @click="goToPreviousPeriod" type="button" :class="scheduleMode == 'edit' ? 'cursor-not-allowed' : 'cursor-pointer'" class="border border-gray-500 hover:bg-[#F5F7F9] flex items-center justify-center py-1 px-2 rounded-l">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1rem" width="1rem" viewBox="-200 -960 960 960" fill="currentColor"><path d="M410-69.85-1.15-481 410-892.15l73.77 73.77L146.38-481l337.39 337.38L410-69.85Z"/></svg>
                    </button>
                    <button @click="goToCurrentPeriod" id="open-period-selection-button" type="button" :class="scheduleMode == 'edit' ? 'cursor-not-allowed' : 'cursor-pointer'" class="min-w-[13rem] border border-gray-500 flex items-center justify-center py-1 px-4 hover:bg-[#F5F7F9]">
                        <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" height="1rem" width="1rem" viewBox="0 -960 960 960" fill="currentColor"><path d="M206.31-70q-41.03 0-69.67-28.64T108-168.31v-547.38q0-41.03 28.64-69.67T206.31-814h23.38v-80.61h87.54V-814h327.08v-80.61h86V-814h23.38q41.03 0 69.67 28.64T852-715.69v547.38q0 41.03-28.64 69.67T753.69-70H206.31Zm0-86h547.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-399.38H194v399.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85ZM194-653.69h572v-62q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H206.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v62Zm0 0V-728v74.31Zm286 262.77q-16.69 0-29.04-12.35-12.34-12.34-12.34-29.04 0-16.69 12.34-29.04 12.35-12.34 29.04-12.34 16.69 0 29.04 12.34 12.34 12.35 12.34 29.04 0 16.7-12.34 29.04-12.35 12.35-29.04 12.35Zm-160 0q-16.69 0-29.04-12.35-12.34-12.34-12.34-29.04 0-16.69 12.34-29.04 12.35-12.34 29.04-12.34 16.69 0 29.04 12.34 12.34 12.35 12.34 29.04 0 16.7-12.34 29.04-12.35 12.35-29.04 12.35Zm320 0q-16.69 0-29.04-12.35-12.34-12.34-12.34-29.04 0-16.69 12.34-29.04 12.35-12.34 29.04-12.34 16.69 0 29.04 12.34 12.34 12.35 12.34 29.04 0 16.7-12.34 29.04-12.35 12.35-29.04 12.35ZM480-234q-16.69 0-29.04-12.35-12.34-12.34-12.34-29.03 0-16.7 12.34-29.04 12.35-12.35 29.04-12.35 16.69 0 29.04 12.35 12.34 12.34 12.34 29.04 0 16.69-12.34 29.03Q496.69-234 480-234Zm-160 0q-16.69 0-29.04-12.35-12.34-12.34-12.34-29.03 0-16.7 12.34-29.04 12.35-12.35 29.04-12.35 16.69 0 29.04 12.35 12.34 12.34 12.34 29.04 0 16.69-12.34 29.03Q336.69-234 320-234Zm320 0q-16.69 0-29.04-12.35-12.34-12.34-12.34-29.03 0-16.7 12.34-29.04 12.35-12.35 29.04-12.35 16.69 0 29.04 12.35 12.34 12.34 12.34 29.04 0 16.69-12.34 29.03Q656.69-234 640-234Z"/></svg>
                        <span ref="currentSchedulePeriodLabel" data-type-period="day">{{ currentSchedulePeriod.verbose }}</span>
                    </button>
                    <button @click="goToNextPeriod" type="button" :class="scheduleMode == 'edit' ? 'cursor-not-allowed' : 'cursor-pointer'" class="border border-gray-500 flex items-center justify-center py-1 px-2 rounded-r hover:bg-[#F5F7F9]">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1rem" width="1rem" viewBox="0 -960 960 960" fill="currentColor"><path d="m317.62-69.85-73.77-73.77L581.23-481 243.85-818.38l73.77-73.77L728.77-481 317.62-69.85Z"/></svg>
                    </button>
                </div>
            </div>
        </div>
    </section>

    <div class="mx-8 px-8 py-4 mb-4 bg-white rounded-md">
        <p class="text-center text-sm">Плагин находится в бета-версии и доступен всем пользователям бесплатно в целях тестирования и получения обратной связи</p>
    </div>
    <div v-if="activeStaffs.length === 0" class="mx-8 px-8 py-4 mb-4 bg-white rounded-md text-center">У вас пока нет ни одного активного сотрудника</div>
    <div v-else-if="!checkKassaByActiveStaffs" class="mx-8 px-8 py-4 mb-4 bg-white rounded-md text-center">В выбранной кассе пока нет ни одного активного сотрудника</div>
    <template v-else>
        <section ref="scheduleSection" class="mx-8 px-8 py-6 mb-[1rem] bg-white rounded-md select-none">
            <div class="flex items-center justify-between mb-[1rem]">
                <p>{{ `Таблица графика сотрудников за ${currentSchedulePeriod.verbose.toLowerCase()}` }}</p>
                <svg v-if="scheduleMode == 'show' && hasAccessToEditSchedule" @click="goToEditScheduleMode(good)" :class="checkPeriodToEditable() ? 'cursor-pointer' : 'cursor-not-allowed'" class="w-5 h-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"/></svg>
                <div v-else-if="scheduleMode == 'edit'" class="flex items-center gap-[1rem]">
                    <svg @click="saveNewSchedule" class="text-green-500 hover:text-green-600 cursor-pointer" width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.02344 8.80761L7.71627 15.1421L21.8584 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                    <svg @click="deleteNewSchedule" class="text-red-500 hover:text-red-600 cursor-pointer" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.8584 15.1421L8.92947 8.07107M8.92947 8.07107L16.0005 1M8.92947 8.07107L1.85864 1.00024M8.92947 8.07107L16.0005 15.1421" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                </div>
            </div>
            <div v-if="scheduleMode == 'edit'" class="mb-[1rem] flex items-center justify-between gap-[0.5rem]">
                <div ref="dayHourBlock" class="relative w-full">
                    <div @click="openCloseDayHourOptionBlock" class="flex items-center justify-between text-[#FF8C00] hover:text-[#CB750C] w-full px-[1rem] py-[0.75rem] rounded-lg border border-[#838B9B] cursor-pointer">
                        <span class="whitespace-nowrap shrink-0">Дневные часы</span>
                        <IconSelectArrowDown class="w-2.5 h-2.5 shrink-0 ml-4"/>
                    </div>
                    <div v-show="dayHoursOptionsIsOpened" class="absolute mt-2 p-4 border rounded-lg bg-white w-full flex flex-col gap-2 items-center">
                        <button @click="selectDayHours(4)" type="button" class="w-full text-[#FF8C00] hover:text-[#CB750C]">4</button>
                        <button @click="selectDayHours(8)" type="button" class="w-full text-[#FF8C00] hover:text-[#CB750C]">8</button>
                        <button @click="selectDayHours(12)" type="button" class="w-full text-[#FF8C00] hover:text-[#CB750C]">12</button>
                        <button @click="selectDayHours(24)" type="button" class="w-full text-[#FF8C00] hover:text-[#CB750C]">24</button>
                        <label for="custom-day-hours" class="w-full flex items-center gap-2">
                            <input ref="dayHoursAmountInput" @input="handleAmountHoursInput" type="text" id="custom-day-hours" class="rounded-lg w-full">
                            <button @click="selectCustomDayHours" type="button"><svg class="text-[#FF8C00] hover:text-[#CB750C] w-8 h-8 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg></button>
                        </label>
                    </div>
                </div>
                <div ref="nightHourBlock" class="relative w-full">
                    <div @click="openCloseNightHourOptionBlock" class="flex items-center justify-between text-[#0074D9] hover:text-[#0660AF] w-full px-[1rem] py-[0.75rem] rounded-lg border border-[#838B9B] cursor-pointer">
                        <span class="whitespace-nowrap shrink-0">Ночные часы</span>
                        <IconSelectArrowDown class="w-2.5 h-2.5 shrink-0 ml-4"/>
                    </div>
                    <div v-show="nightHoursOptionsIsOpened" class="absolute mt-2 p-4 border rounded-lg bg-white w-full flex flex-col gap-2 items-center">
                        <button @click="selectNightHours(4)" type="button" class="w-full text-[#0074D9] hover:text-[#0660AF]">4</button>
                        <button @click="selectNightHours(8)" type="button" class="w-full text-[#0074D9] hover:text-[#0660AF]">8</button>
                        <button @click="selectNightHours(12)" type="button" class="w-full text-[#0074D9] hover:text-[#0660AF]">12</button>
                        <button @click="selectNightHours(24)" type="button" class="w-full text-[#0074D9] hover:text-[#0660AF]">24</button>
                        <label for="custom-day-hours" class="w-full flex items-center gap-2">
                            <input ref="nightHoursAmountInput" @input="handleAmountHoursInput" type="text" id="custom-night-hours" class="rounded-lg w-full">
                            <button @click="selectCustomNightHours" type="button"><svg class="text-[#0074D9] hover:text-[#0660AF] w-8 h-8 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg></button>
                        </label>
                    </div>
                </div>
                <button type="button" @click="markSelectedCell('day shift')" class="w-full whitespace-nowrap px-[1rem] py-[0.75rem] rounded-lg border border-[#838B9B] bg-[#F5F8CC] hover:bg-[#ECF0B1]">Дневная смена</button>
                <button type="button" @click="markSelectedCell('night shift')" class="w-full whitespace-nowrap px-[1rem] py-[0.75rem] rounded-lg border border-[#838B9B] bg-[#DDEBF7] hover:bg-[#D2E9FC]">Ночная смена</button>
                <button type="button" @click="markSelectedCell('absence')" class="w-full whitespace-nowrap px-[1rem] py-[0.75rem] rounded-lg border border-[#838B9B] bg-[#F4CCCC] hover:bg-[#EEC0C0]">Пропуск</button>
                <button type="button" @click="markSelectedCell('sick leave')" class="w-full whitespace-nowrap px-[1rem] py-[0.75rem] rounded-lg border border-[#838B9B] bg-[#D9EAD3] hover:bg-[#CDE6C4]">Больничный</button>
                <button type="button" @click="markSelectedCell('vacation')" class="w-full whitespace-nowrap px-[1rem] py-[0.75rem] rounded-lg border border-[#838B9B] bg-[#FCE5CD] hover:bg-[#F6D9BB]">Отпуск</button>
                <button type="button" @click="markSelectedCell('')" class="w-full whitespace-nowrap px-[1rem] py-[0.75rem] rounded-lg border border-[#838B9B] hover:bg-[#dddddd]">Пусто</button>
            </div>
            <div class="overflow-x-scroll no-scrollbar">
                <table class="w-full border-separate rounded-lg text-sm">
                    <thead>
                    <tr>
                        <th :data-x="-1" :data-y="-1" class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] rounded-tl-lg"></th>
                        <th v-for="(number, numberIndex) in getAmountOfDaysInMonth(Number(currentSchedulePeriod.date.split('-')[0]), Number(currentSchedulePeriod.date.split('-')[1]))" :key="number" :data-x="numberIndex" :data-y="-1" @click="selectCurrentColumn(numberIndex)" class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] min-w-[2rem] last:rounded-tr-lg" :class="{'cursor-pointer hover:bg-[#e2e1e1]': scheduleMode == 'edit',}">
                            <p>{{ number }}</p>
                            <p class="text-[0.55rem]">{{ $globalMethods.getWeekDayByDate(`${currentSchedulePeriod.date.split('-')[0]}-${currentSchedulePeriod.date.split('-')[1]}-${number.toString().padStart(2, "0")}`)}}</p>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(staff, staffIndex) in activeStaffs" :key="staff.id">
                        <tr v-if="currentKassa === 'all' || staff.shops.includes(currentKassa)" :class="{'bg-gray-200': staffIndex % 2 === 1}">
                            <td :data-x-="-1" :data-y="staffIndex" @click="selectCurrenRow(staffIndex)" class="px-[1rem] py-[0.5rem] text-left font-normal outline outline-[#a5a6af]" :class="{'first:rounded-bl-lg': staffIndex === staffs.length - 1, 'cursor-pointer hover:bg-[#e2e1e1]': scheduleMode === 'edit',}">{{ staff.name }}</td>
                            <td v-for="(number, numberIndex) in getAmountOfDaysInMonth(Number(currentSchedulePeriod.date.split('-')[0]), Number(currentSchedulePeriod.date.split('-')[1]))" :key="number"
                                :data-x="numberIndex" :data-y="staffIndex"
                                @click="selectCurrentCell(numberIndex, staffIndex)"
                                class="box-border px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] min-w-[2rem]"
                                :class="{
                                    'cursor-pointer hover:bg-[#e2e1e1]': scheduleMode === 'edit',
                                    'last:rounded-br-lg': staffIndex === activeStaffs.length - 1,
                                    'border border-blue-500 bg-blue-200': selectedTableCellMatrix[staffIndex][numberIndex],
                                    'border border-transparent': !selectedTableCellMatrix[staffIndex][numberIndex],
                                    'bg-[#F5F8CC]': scheduleMatrix[staffIndex].content[numberIndex] === 'day shift',
                                    'bg-[#DDEBF7]': scheduleMatrix[staffIndex].content[numberIndex] === 'night shift',
                                    'bg-[#F4CCCC]': scheduleMatrix[staffIndex].content[numberIndex] === 'absence',
                                    'bg-[#D9EAD3]': scheduleMatrix[staffIndex].content[numberIndex] === 'sick leave',
                                    'bg-[#FCE5CD]': scheduleMatrix[staffIndex].content[numberIndex] === 'vacation',
                                    'text-[#FF8C00]': scheduleMatrix[staffIndex].content[numberIndex] && scheduleMatrix[staffIndex].content[numberIndex].includes('day hours'),
                                    'text-[#0074D9]': scheduleMatrix[staffIndex].content[numberIndex] && scheduleMatrix[staffIndex].content[numberIndex].includes('night hours'),
                                }"
                            >{{ getVerboseScheduleLabel(scheduleMatrix[staffIndex].content[numberIndex]) }}</td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
        </section>

        <section class="mx-8 px-8 py-6 mb-[1rem] bg-white rounded-md">
            <div class="flex items-center justify-between mb-4">
                <p>{{ `Таблица расчета заработной платы за ${currentSchedulePeriod.verbose.toLowerCase()}` }}</p>
                <button v-if="hasAccessToShowSalaryReportsOfAllStaffs" @click="printTableOfSalaryReports" type="button" class="relative border border-custom-blue hover:bg-gray-100 text-sm text-custom-blue py-2 rounded-md flex items-center font-medium px-5 whitespace-nowrap">
                    <svg class="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M640-640v-120H320v120h-80v-200h480v200h-80Zm-480 80h640-640Zm560 100q17 0 28.5-11.5T760-500q0-17-11.5-28.5T720-540q-17 0-28.5 11.5T680-500q0 17 11.5 28.5T720-460Zm-80 260v-160H320v160h320Zm80 80H240v-160H80v-240q0-51 35-85.5t85-34.5h560q51 0 85.5 34.5T880-520v240H720v160Zm80-240v-160q0-17-11.5-28.5T760-560H200q-17 0-28.5 11.5T160-520v160h80v-80h480v80h80Z"/></svg>
                    <span>Напечатать</span>
                </button>
            </div>
            <div ref="salaryReportTableBlock">
                <table class="w-full border-separate print:border-collapse rounded-lg text-sm">
                    <thead>
                    <tr>
                        <th class="px-4 py-[0.5rem] text-left font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af] rounded-tl-lg">Сотрудник</th>
                        <th class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af] min-w-[5.63625rem]">% с продаж</th>
                        <th class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af] min-w-[5.63625rem]">Дневные смены</th>
                        <th class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af] min-w-[5.63625rem]">Ночные смены</th>
                        <th class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af] min-w-[5.63625rem]">Часы за день</th>
                        <th class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af] min-w-[5.63625rem]">Часы за ночь</th>
                        <th class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af] min-w-[5.63625rem]">Итог</th>
                        <th class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">Штрафы</th>
                        <th class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af] min-w-[5.63625rem]">Выплачено</th>
                        <th class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af] rounded-tr-lg min-w-[5.63625rem]">Осталось выплатить</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(salaryReport, salaryReportIndex) in verboseSalaryReports.elements" :key="salaryReport.staff.id" :class="{'bg-gray-200': salaryReportIndex % 2 === 1}">
                        <td :class="!hasAccessToShowSalaryReportsOfAllStaffs ? 'first:rounded-bl-lg' : ''" class="px-4 py-[0.5rem] text-left font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ salaryReport.staff.name }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ $globalMethods.formatNumberWithSpaces(salaryReport.total_per_sales) || "0.00" }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ `${$globalMethods.formatNumberWithSpaces(salaryReport.total_per_day_shifts) || "0.00"} (${salaryReport.amount_of_day_shifts || "0"})` }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ `${$globalMethods.formatNumberWithSpaces(salaryReport.total_per_night_shifts) || "0.00"} (${salaryReport.amount_of_night_shifts || "0"})` }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ `${$globalMethods.formatNumberWithSpaces(salaryReport.total_per_day_hours) || "0.00"} (${salaryReport.amount_of_day_hours || "0"})` }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ `${$globalMethods.formatNumberWithSpaces(salaryReport.total_per_night_hours) || "0.00"} (${salaryReport.amount_of_night_hours || "0"})` }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ $globalMethods.formatNumberWithSpaces(salaryReport.accrual_result) || "0.00" }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ $globalMethods.formatNumberWithSpaces(salaryReport.penalty_payout) || "0.00" }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ $globalMethods.formatNumberWithSpaces(salaryReport.payout_result) || "0.00" }}</td>
                        <td :class="!hasAccessToShowSalaryReportsOfAllStaffs ? 'last:rounded-br-lg' : ''" class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ $globalMethods.formatNumberWithSpaces(Number(salaryReport.accrual_result) - (Number(salaryReport.payout_result) + Number(salaryReport.penalty_payout))) || "0.00" }}</td>
                    </tr>
                    <tr v-if="hasAccessToShowSalaryReportsOfAllStaffs">
                        <td class="first:rounded-bl-lg px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">Итого</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ $globalMethods.formatNumberWithSpaces(verboseSalaryReports.totals.total_per_sales.toFixed(2)) || "0.00" }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ `${$globalMethods.formatNumberWithSpaces(verboseSalaryReports.totals.total_per_day_shifts.toFixed(2)) || "0.00"}` }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ `${$globalMethods.formatNumberWithSpaces(verboseSalaryReports.totals.total_per_night_shifts.toFixed(2)) || "0.00"}` }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ `${$globalMethods.formatNumberWithSpaces(verboseSalaryReports.totals.total_per_day_hours.toFixed(2)) || "0.00"}` }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ `${$globalMethods.formatNumberWithSpaces(verboseSalaryReports.totals.total_per_night_hours.toFixed(2)) || "0.00"}` }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ $globalMethods.formatNumberWithSpaces(verboseSalaryReports.totals.accrual_result.toFixed(2)) || "0.00" }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ $globalMethods.formatNumberWithSpaces(verboseSalaryReports.totals.penalty_payout.toFixed(2)) || "0.00" }}</td>
                        <td class="px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ $globalMethods.formatNumberWithSpaces(verboseSalaryReports.totals.payout_result.toFixed(2)) || "0.00" }}</td>
                        <td class="last:rounded-br-lg px-[0.5rem] py-[0.5rem] text-center font-normal outline outline-[#a5a6af] print:outline-none print:border print:border-[#a5a6af]">{{ $globalMethods.formatNumberWithSpaces((verboseSalaryReports.totals.accrual_result - (verboseSalaryReports.totals.payout_result + verboseSalaryReports.totals.penalty_payout)).toFixed(2)) || "0.00" }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </template>

    <section class="mx-8 py-6 mb-12 bg-white rounded-md">
        <div class="px-8 flex items-center justify-between mb-[1rem]">
            <p>{{ `Таблица выплат за ${currentSchedulePeriod.verbose.toLowerCase()}` }}</p>
            <button v-if="hasAccessToAddPayout" @click="openAddPayoutWindow" type="button" class="border border-custom-blue bg-custom-blue hover:bg-custom-blue-hover flex items-center text-white font-medium rounded-lg text-sm px-5 py-2 whitespace-nowrap">
                <svg class="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M438-274h86v-162h162v-86H524v-164h-86v164H274v86h164v162Zm42.07 206q-85.48 0-160.69-32.44t-130.84-88.05q-55.63-55.61-88.09-130.79Q68-394.46 68-479.93q0-85.74 32.5-161.17 32.5-75.43 88.21-131.23 55.71-55.8 130.79-87.74Q394.57-892 479.93-892q85.73 0 161.15 31.92 75.43 31.92 131.24 87.71 55.81 55.79 87.75 131.21Q892-565.74 892-479.98q0 85.75-31.92 160.62t-87.7 130.6q-55.78 55.73-131.18 88.25Q565.8-68 480.07-68Z"/></svg>
                <span>Добавить</span>
            </button>
        </div>
        <div>
            <table class="w-full text-sm">
                <thead>
                    <tr class="border-b">
                        <th class="px-[2rem] py-[0.75rem] text-start font-normal">
                            <div @click="sortBy('date')" class="flex items-center gap-[1rem] cursor-pointer">
                                <span>Дата</span>
                                <IconUnactiveSort v-if="sortedBy != 'date-ascending' && sortedBy != 'date-descending'" class="text-gray-500 w-4 h-4 shrink-0"/>
                                <IconSortAscendingByNumber v-if="sortedBy == 'date-ascending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                                <IconSortDescendingByNumber v-if="sortedBy == 'date-descending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                            </div>
                        </th>
                        <th class="px-[2rem] py-[0.75rem] text-start font-normal">
                            <div @click="sortBy('period')" class="flex items-center gap-[1rem] cursor-pointer">
                                <span>Период</span>
                                <IconUnactiveSort v-if="sortedBy != 'period-ascending' && sortedBy != 'period-descending'" class="text-gray-500 w-4 h-4 shrink-0"/>
                                <IconSortAscendingByNumber v-if="sortedBy == 'period-ascending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                                <IconSortDescendingByNumber v-if="sortedBy == 'period-descending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                            </div>
                        </th>
                        <th class="px-[2rem] py-[0.75rem] text-start font-normal">
                            <div @click="sortBy('created-by')" class="flex items-center gap-[1rem] cursor-pointer">
                                <span>Кто сделал</span>
                                <IconUnactiveSort v-if="sortedBy != 'created-by-ascending' && sortedBy != 'created-by-descending'" class="text-gray-500 w-4 h-4 shrink-0"/>
                                <IconSortAscendingByAlphabet v-if="sortedBy == 'created-by-ascending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                                <IconSortDescendingByAlphabet v-if="sortedBy == 'created-by-descending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                            </div>
                        </th>
                        <th class="px-[2rem] py-[0.75rem] text-start font-normal">
                            <div @click="sortBy('type')" class="flex items-center gap-[1rem] cursor-pointer">
                                <span>Тип выплаты</span>
                                <IconUnactiveSort v-if="sortedBy != 'type-ascending' && sortedBy != 'type-descending'" class="text-gray-500 w-4 h-4 shrink-0"/>
                                <IconSortAscendingByAlphabet v-if="sortedBy == 'type-ascending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                                <IconSortDescendingByAlphabet v-if="sortedBy == 'type-descending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                            </div>
                        </th>
                        <th class="px-[2rem] py-[0.75rem] text-start font-normal">
                            <div @click="sortBy('staff')" class="flex items-center gap-[1rem] cursor-pointer">
                                <span>Сотрудник</span>
                                <IconUnactiveSort v-if="sortedBy != 'staff-ascending' && sortedBy != 'staff-descending'" class="text-gray-500 w-4 h-4 shrink-0"/>
                                <IconSortAscendingByAlphabet v-if="sortedBy == 'staff-ascending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                                <IconSortDescendingByAlphabet v-if="sortedBy == 'staff-descending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                            </div>
                        </th>
                        <th class="px-[2rem] py-[0.75rem] text-start font-normal">
                            <div @click="sortBy('price')" class="flex items-center gap-[1rem] cursor-pointer">
                                <span>Размер выплаты</span>
                                <IconUnactiveSort v-if="sortedBy != 'price-ascending' && sortedBy != 'price-descending'" class="text-gray-500 w-4 h-4 shrink-0"/>
                                <IconSortAscendingByNumber v-if="sortedBy == 'price-ascending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                                <IconSortDescendingByNumber v-if="sortedBy == 'price-descending'" class="text-indigo-500 w-4 h-4 shrink-0"/>
                            </div>
                        </th>
                        <th class="px-[2rem] py-[0.75rem] text-start font-normal">Комментарий</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="sortedPayouts.length == 0">
                        <td colspan="7" class="text-center pt-4">За выбранный период нет выплат</td>
                    </tr>
                    <tr v-for="(payout, payoutIndex) in sortedPayouts" :key="payout.id" @click="openPayoutDetailWindow(payout)" class="border-b cursor-pointer" :class="{'!bg-[#f2d0db] !hover:bg-red-50': payout.is_deleted, 'bg-white hover:bg-gray-50': payoutIndex % 2 === 0, 'bg-gray-200 hover:bg-gray-50': payoutIndex % 2 === 1}">
                        <td class="px-[2rem] py-[0.5rem] text-start" :class="payout.is_deleted ? 'line-through' : ''">{{ $globalMethods.formatDate('ru', payout.datetime_of_created) }}</td>
                        <td class="px-[2rem] py-[0.5rem] text-start">{{ $globalMethods.getMonthAndYear(payout.target_period, "short") }}</td>
                        <td class="px-[2rem] py-[0.5rem] text-start">{{ payout.created_by ? payout.created_by.name : companyData.founder.name }}</td>
                        <td class="px-[2rem] py-[0.5rem] text-start">{{ labels.payoutTypes[payout.type] }}</td>
                        <td class="px-[2rem] py-[0.5rem] text-start">{{ payout.staff.name }}</td>
                        <td class="px-[2rem] py-[0.5rem] text-start">{{ $globalMethods.formatNumberWithSpaces(payout.total) }}</td>
                        <td class="px-[2rem] py-[0.5rem] text-start">{{ payout.note || " " }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script>
    import IconUnactiveSort from '@/components/Icon/IconUnactiveSort.vue';
    import IconSortAscendingByNumber from '@/components/Icon/IconSortAscendingByNumber.vue';
    import IconSortDescendingByNumber from '@/components/Icon/IconSortDescendingByNumber.vue';
    import IconSortAscendingByAlphabet from '@/components/Icon/IconSortAscendingByAlphabet.vue';
    import IconSortDescendingByAlphabet from '@/components/Icon/IconSortDescendingByAlphabet.vue';
    import IconSelectArrowDown from '@/components/Icon/IconSelectArrowDown.vue';

    import AddPayoutWindow from './AddPayoutWindow.vue';
    import PayoutDetailWindow from './PayoutDetailWindow.vue';
    import PrintScheduleAndSalaryWindow from './PrintScheduleAndSalaryWindow.vue';
    import ScheduleAndSalaryDetailWindow from './ScheduleAndSalaryDetailWindow.vue';

    import { mapState } from 'vuex';

    export default {
        name: "ScheduleAndSalary",
        components: {
            IconUnactiveSort,
            IconSortAscendingByNumber,
            IconSortDescendingByNumber,
            IconSortAscendingByAlphabet,
            IconSortDescendingByAlphabet,
            IconSelectArrowDown,
            AddPayoutWindow,
            PayoutDetailWindow,
            PrintScheduleAndSalaryWindow,
            ScheduleAndSalaryDetailWindow,
        },
        props: {
            mode: {
                type: String,
                required: true,
            }
        },
        computed: {
            ...mapState(["role", "personalStaffData", "companyData", "staffs", "schedules", "currentSchedulePeriod", "payouts", "labels", "salaryReports", "startDateOfSalaryAndSchedulePlugin", "kassas"]),
            sortedPayouts() {
                let result;
                if (this.currentKassa !== "all") {
                    result = this.payouts.filter(payout => payout.staff.shops.includes(this.currentKassa));
                } else {
                    result = [...this.payouts];
                }
                result.sort((payout1, payout2) => new Date(payout2.datetime_of_created) - new Date(payout1.datetime_of_created));

                if (this.sortedBy == "date-ascending") {
                    result.sort((payout1, payout2) => new Date(payout1.datetime_of_created) - new Date(payout2.datetime_of_created));
                } else if (this.sortedBy == "date-descending") {
                    result.sort((payout1, payout2) => new Date(payout2.datetime_of_created) - new Date(payout1.datetime_of_created));
                } else if (this.sortedBy == "period-ascending") {
                    result.sort((payout1, payout2) => new Date(payout1.target_period) - new Date(payout2.target_period));
                } else if (this.sortedBy == "period-descending") {
                    result.sort((payout1, payout2) => new Date(payout2.target_period) - new Date(payout1.target_period));
                } else if (this.sortedBy == "created-by-ascending") {
                    result.sort((payout1, payout2) => (payout1.created_by || this.companyData.founder.name).localeCompare(payout2.created_by || this.companyData.founder.name));
                } else if (this.sortedBy == "created-by-descending") {
                    result.sort((payout1, payout2) => (payout2.created_by || this.companyData.founder.name).localeCompare(payout1.created_by || this.companyData.founder.name));
                } else if (this.sortedBy == "type-ascending") {
                    result.sort((payout1, payout2) => payout1.type.localeCompare(payout2.type));
                } else if (this.sortedBy == "type-descending") {
                    result.sort((payout1, payout2) => payout2.type.localeCompare(payout1.type));
                } else if (this.sortedBy == "staff-ascending") {
                    result.sort((payout1, payout2) => payout1.staff.name.localeCompare(payout2.staff.name));
                } else if (this.sortedBy == "staff-descending") {
                    result.sort((payout1, payout2) => payout2.staff.name.localeCompare(payout1.staff.name));
                } else if (this.sortedBy == "price-ascending") {
                    result.sort((payout1, payout2) => Number(payout1.total) - Number(payout2.total));
                } else if (this.sortedBy == "price-descending") {
                    result.sort((payout1, payout2) => Number(payout2.total) - Number(payout1.total));
                }
                return result;
            },
            activeStaffs() {
                return this.staffs.filter(staff => staff.is_active)
            },
            checkKassaByActiveStaffs() {
                if (this.currentKassa === 'all') return true;
                for (const staff of this.activeStaffs) {
                    if (staff.shops.includes(this.currentKassa)) return true;
                }
                return false;
            },
            verboseSalaryReports() {
                let result = {
                    elements: [],
                    totals: {
                        total_per_sales: 0,
                        total_per_day_shifts: 0,
                        total_per_night_shifts: 0,
                        total_per_day_hours: 0,
                        total_per_night_hours: 0,
                        accrual_result: 0,
                        penalty_payout: 0,
                        payout_result: 0,
                    },
                };
                for (const staff of this.activeStaffs) {
                    if (this.currentKassa !== 'all' && !staff.shops.includes(this.currentKassa)) continue;
                    const staffSalaryReport = this.salaryReports.find(salaryReport => salaryReport.staff.id === staff.id);
                    if (staffSalaryReport) {
                        result.elements.push(staffSalaryReport);
                        result.totals.total_per_sales += Number(staffSalaryReport.total_per_sales);
                        result.totals.total_per_day_shifts += Number(staffSalaryReport.total_per_day_shifts);
                        result.totals.total_per_night_shifts += Number(staffSalaryReport.total_per_night_shifts);
                        result.totals.total_per_day_hours += Number(staffSalaryReport.total_per_day_hours);
                        result.totals.total_per_night_hours += Number(staffSalaryReport.total_per_night_hours);
                        result.totals.accrual_result += Number(staffSalaryReport.accrual_result);
                        result.totals.penalty_payout += Number(staffSalaryReport.penalty_payout);
                        result.totals.payout_result += Number(staffSalaryReport.payout_result);
                    } else if (this.hasAccessToShowSalaryReportsOfAllStaffs) {
                        result.elements.push({"staff": staff});
                    }
                }
                return result;
            },
            hasAccessToShowSalaryReportsOfAllStaffs() {
                return this.hasAccessToAddPayout;
            },
            hasAccessToAddPayout() {
                return this.role === "founder" || this.personalStaffData.add_payout_permission;
            },
            hasAccessToEditSchedule() {
                return this.role === "founder" || this.personalStaffData.edit_schedule_permission;
            }
        },
        data() {
            return {
                addPayoutWindowIsOpened: false,
                payoutDetailWindowIsOpened: false,
                dayHoursOptionsIsOpened: false,
                nightHoursOptionsIsOpened: false,
                printScheduleAndSalaryWindowIsOpened: false,
                scheduleAndSalaryDetailWindowIsOpened: false,
                scheduleMode: "show",
                selectedTableCellMatrix: [],
                scheduleMatrix: [],
                sortedBy: "date-descending",
                isSelecting: false,
                mouseMoveStart: [0, 0],
                lastClickedCell: [0, 0],
                currentPayout: {},
                addSignForm: true,
                currentKassa: "all",
            }
        },
        methods: {
            printTableOfSalaryReports() {
                const printContent = this.$refs.salaryReportTableBlock.innerHTML;
                const newWindow = window.open("", "_blank");

                const styles = [...document.styleSheets].map(sheet => {
                    try {
                        return [...sheet.cssRules].map(rule => rule.cssText).join("\n");
                    } catch (e) {
                        return "";
                    }
                }).join("\n");

                newWindow.document.write(`
                    <html lang="ru-RU">
                    <head>
                        <title>Печать</title>
                        <style>${styles}</style>
                    </head>
                    <body class="p-8" style="zoom: 0.6;">
                        <h1 class='mb-4'>Таблица расчета заработной платы за ${this.currentSchedulePeriod.verbose.toLowerCase()}</h1>
                        ${printContent}
                    </body>
                    </html>
                `);

                newWindow.document.close();
                newWindow.print();
                newWindow.close();
            },
            openScheduleAndSalaryDetailWindowIsOpened() {
                this.scheduleAndSalaryDetailWindowIsOpened = true;
                document.body.classList.add("overflow-hidden");
            },
            openPrintScheduleAndSalaryWindow() {
                this.printScheduleAndSalaryWindowIsOpened = true;
                document.body.classList.add("overflow-hidden");
            },
            sortBy(param) {
                if (param == "date") {
                    if (this.sortedBy == "date-ascending") {
                        this.sortedBy = "date-descending";
                    } else {
                        this.sortedBy = "date-ascending";
                    }
                } else if (param == "period") {
                    if (this.sortedBy == "period-ascending") {
                        this.sortedBy = "period-descending";
                    } else {
                        this.sortedBy = "period-ascending";
                    }
                } else if (param == "created-by") {
                    if (this.sortedBy == "created-by-ascending") {
                        this.sortedBy = "created-by-descending";
                    } else {
                        this.sortedBy = "created-by-ascending";
                    }
                } else if (param == "type") {
                    if (this.sortedBy == "type-ascending") {
                        this.sortedBy = "type-descending";
                    } else {
                        this.sortedBy = "type-ascending";
                    }
                } else if (param == "staff") {
                    if (this.sortedBy == "staff-ascending") {
                        this.sortedBy = "staff-descending";
                    } else {
                        this.sortedBy = "staff-ascending";
                    }
                } else if (param == "price") {
                    if (this.sortedBy == "price-ascending") {
                        this.sortedBy = "price-descending";
                    } else {
                        this.sortedBy = "price-ascending";
                    }
                }
            },
            openPayoutDetailWindow(payout) {
                this.currentPayout = payout;
                this.payoutDetailWindowIsOpened = true;
                document.body.classList.add("overflow-hidden");
            },
            async saveNewSchedule() {
                const existingSchedules = {};
                const newSchedules = [];
                for (const schedule of this.scheduleMatrix) {
                    if (schedule.id) {
                        existingSchedules[schedule.id] = {};
                        let index = 0;
                        for (const value of Object.values(schedule.content)) {
                            index += 1;
                            existingSchedules[schedule.id][String(index)] = value;
                        }
                    } else {
                        const newSchedule = {};
                        newSchedule.staff = schedule.staff;
                        newSchedule.date = this.currentSchedulePeriod.date;

                        const content = {};
                        let index = 0;
                        for (const value of Object.values(schedule.content)) {
                            index += 1;
                            content[String(index)] = value;
                        }
                        newSchedule.content = content;

                        newSchedules.push(newSchedule);
                    }
                }
                const result = await this.$store.dispatch("updateSchedules", {existingSchedules: existingSchedules, newSchedules: newSchedules});
                if (result.successfully) {
                    this.goToShowScheduleMode();
                    this.initSelectedTableCellMatrix();
                    this.$notify("Раписание сотрудников успешно обновлено!", "black", 3000);
                }
            },
            async deleteNewSchedule() {
                this.scheduleMode = "show";
                this.initSelectedTableCellMatrix();
                this.initScheduleMatrix();
            },

            openCloseDayHourOptionBlock() {
                this.dayHoursOptionsIsOpened = !this.dayHoursOptionsIsOpened;
            },
            openDayHourOptionBlock() {
                this.dayHoursOptionsIsOpened = true;
            },
            closeDayHourOptionBlock() {
                this.dayHoursOptionsIsOpened = false;
            },
            autoCloseDayHourOptionBlock(event) {
                if (this.$refs.dayHourBlock && this.$refs.dayHourBlock.contains(event.target)) return;
                this.closeDayHourOptionBlock();
            },
            addAutoCloseDayHourOptionBlock() {
                document.addEventListener("click", this.autoCloseDayHourOptionBlock);
            },
            removeAutoCloseDayHourOptionBlock() {
                document.removeEventListener("click", this.autoCloseDayHourOptionBlock);
            },

            openCloseNightHourOptionBlock() {
                this.nightHoursOptionsIsOpened = !this.nightHoursOptionsIsOpened;
            },
            openNightHourOptionBlock() {
                this.nightHoursOptionsIsOpened = true;
            }, 
            closeNightHourOptionBlock() {
                this.nightHoursOptionsIsOpened = false;
            },
            autoCloseNightHourOptionBlock(event) {
                if (this.$refs.nightHourBlock && this.$refs.nightHourBlock.contains(event.target)) return;
                this.closeNightHourOptionBlock();
            },
            addAutoCloseNightHourOptionBlock() {
                document.addEventListener("click", this.autoCloseNightHourOptionBlock);
            },
            removeAutoCloseNightHourOptionBlock() {
                document.removeEventListener("click", this.autoCloseNightHourOptionBlock);
            },

            getVerboseScheduleLabel(value) {
                if (!value) return;
                if (this.labels.schedule[value]) return this.labels.schedule[value];
                if (value.includes("day hours")) return value.replace("day hours", "").trim();
                if (value.includes("night hours")) return value.replace("night hours", "").trim();
            },

            selectNightHours(nightHours) {
                for (let rowIndex = 0; rowIndex < this.selectedTableCellMatrix.length; rowIndex++) {
                    for (let colIndex = 0; colIndex < this.selectedTableCellMatrix[rowIndex].length; colIndex++) {
                        if (this.selectedTableCellMatrix[rowIndex][colIndex]) {
                            this.scheduleMatrix[rowIndex].content[colIndex] = `${nightHours} night hours`;
                        }
                    }
                }
                this.closeNightHourOptionBlock();
            },
            selectCustomNightHours() {
                this.selectNightHours(this.$refs.nightHoursAmountInput.value);
                this.$refs.nightHoursAmountInput.value = "";
            },

            selectDayHours(dayHours) {
                for (let rowIndex = 0; rowIndex < this.selectedTableCellMatrix.length; rowIndex++) {
                    for (let colIndex = 0; colIndex < this.selectedTableCellMatrix[rowIndex].length; colIndex++) {
                        if (this.selectedTableCellMatrix[rowIndex][colIndex]) {
                            this.scheduleMatrix[rowIndex].content[colIndex] = `${dayHours} day hours`;
                        }
                    }
                }
                this.closeDayHourOptionBlock();
            },
            selectCustomDayHours() {
                this.selectDayHours(this.$refs.dayHoursAmountInput.value);
                this.$refs.dayHoursAmountInput.value = "";
            },

            handleAmountHoursInput(event) {
                if (event.target.value.trim().length == 0) return;
                let result = Number(event.target.value.replace(/\D/g, ''));
                if (result > 24) {
                    event.target.value = 24
                } else if (result < 1) {
                    event.target.value = 1;
                } else {
                    event.target.value = result;
                }
            },

            checkPeriodToEditable() {
                const currentSchedulePeriodDate = new Date(this.currentSchedulePeriod.date);
                let today = new Date();
                let firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);                
                // let lastDayNextMonth = new Date(today.getFullYear(), today.getMonth() + 2, 0);
                return currentSchedulePeriodDate >= firstDayLastMonth
            },
            goToEditScheduleMode() {
                if (!this.checkPeriodToEditable() || !this.hasAccessToEditSchedule) return;
                this.scheduleMode = "edit";
            },
            goToShowScheduleMode() {
                this.scheduleMode = "show";
            },
            getAmountOfDaysInMonth(year, month) {
                return new Date(year, month, 0).getDate();
            },
            openAddPayoutWindow() {
                document.body.classList.add("overflow-hidden");
                this.addPayoutWindowIsOpened = true;
            },
            goToStaffs() {
                this.$emit("update:mode", "staffs");
            },
            async goToPreviousPeriod() {
                if (this.scheduleMode === "edit") return;
                const firstDayOfPreviousMonth = this.$globalMethods.getFirstDayOfPreviousMonth(this.currentSchedulePeriod.date);
                if (this.startDateOfSalaryAndSchedulePlugin > firstDayOfPreviousMonth) {
                    this.$notify("Плагин графиков работы и заработных плат работает на данных с февраля 2025", "block", 5000);
                    return;
                }
                this.$store.dispatch("updateCurrentSchedulePeriod", {date: firstDayOfPreviousMonth, verbose: this.$globalMethods.getMonthAndYear(firstDayOfPreviousMonth)});
                await this.$store.dispatch("fetchSchedules", {dateFrom: this.currentSchedulePeriod.date, dateTo: this.currentSchedulePeriod.date});
                await this.$store.dispatch("fetchPayouts", {targetPeriod: this.currentSchedulePeriod.date});
                await this.$store.dispatch("fetchSalaryReports", this.currentSchedulePeriod.date);
                this.initScheduleMatrix();
            },
            async goToCurrentPeriod() {
                if (this.scheduleMode === "edit") return;
                if (this.currentSchedulePeriod.date === this.$globalMethods.getFirstDayOfCurrentMonth()) return;
                this.$store.dispatch("updateCurrentSchedulePeriod", {date: this.$globalMethods.getFirstDayOfCurrentMonth(), verbose: this.$globalMethods.getCurrentMonthAndYear()});
                await this.$store.dispatch("fetchSchedules", {dateFrom: this.currentSchedulePeriod.date, dateTo: this.currentSchedulePeriod.date});
                await this.$store.dispatch("fetchPayouts", {targetPeriod: this.currentSchedulePeriod.date});
                await this.$store.dispatch("fetchSalaryReports", this.currentSchedulePeriod.date);
                this.initScheduleMatrix();
            },
            async goToNextPeriod() {
                if (this.scheduleMode === "edit") return;
                const firstDayOfNextMonth = this.$globalMethods.getFirstDayOfNextMonth(this.currentSchedulePeriod.date);
                this.$store.dispatch("updateCurrentSchedulePeriod", {date: firstDayOfNextMonth, verbose: this.$globalMethods.getMonthAndYear(firstDayOfNextMonth)});
                await this.$store.dispatch("fetchSchedules", {dateFrom: this.currentSchedulePeriod.date, dateTo: this.currentSchedulePeriod.date});
                await this.$store.dispatch("fetchPayouts", {targetPeriod: this.currentSchedulePeriod.date});
                await this.$store.dispatch("fetchSalaryReports", this.currentSchedulePeriod.date);
                this.initScheduleMatrix();
            },
            markSelectedCell(label) {
                for (let rowIndex = 0; rowIndex < this.selectedTableCellMatrix.length; rowIndex++) {
                    for (let colIndex = 0; colIndex < this.selectedTableCellMatrix[rowIndex].length; colIndex++) {
                        if (this.selectedTableCellMatrix[rowIndex][colIndex]) {
                            this.scheduleMatrix[rowIndex].content[colIndex] = label
                        }
                    }
                }
            },
            selectCurrentColumn(colIndex) {
                if (this.scheduleMode !== "edit") return;
                this.clearColumnsSelectedTableCellMatrix(colIndex);
                let column = this.selectedTableCellMatrix.map(row => row[colIndex]);
                const selected = column.every(cell => cell === true) ? false : true;
                for (let rowIndex = 0; rowIndex < this.selectedTableCellMatrix.length; rowIndex++) {
                    this.selectedTableCellMatrix[rowIndex][colIndex] = selected;
                }
            },
            selectCurrenRow(rowIndex) {
                if (this.scheduleMode !== "edit") return;
                this.clearRowsSelectedTableCellMatrix(rowIndex);
                const row = this.selectedTableCellMatrix[rowIndex];
                const selected = row.every(cell => cell == true) ? false : true;
                for (let colIndex = 0; colIndex < row.length; colIndex++) {
                    this.selectedTableCellMatrix[rowIndex][colIndex] = selected;
                }
            },
            selectCurrentCell(x, y) {
                if (this.scheduleMode !== "edit") return;
                const rowIndex = Number(y);
                const colIndex = Number(x);
                const tableIsUnselected = this.selectedTableCellMatrix.every(row => row.every(cell => cell === false));

                if (event.shiftKey && !tableIsUnselected) {
                    const selected = this.selectedTableCellMatrix[this.lastClickedCell[1]][this.lastClickedCell[0]];
                    if (colIndex == this.lastClickedCell[0] && rowIndex == this.lastClickedCell[1]) {
                        this.selectedTableCellMatrix[rowIndex][colIndex] = !this.selectedTableCellMatrix[rowIndex][colIndex];
                    } else if (colIndex == this.lastClickedCell[0]) {
                        for (let multiRowIndex = Math.min(rowIndex, this.lastClickedCell[1]); multiRowIndex <= Math.max(rowIndex, this.lastClickedCell[1]); multiRowIndex++) {
                            this.selectedTableCellMatrix[multiRowIndex][colIndex] = selected;
                        }
                    } else if (rowIndex == this.lastClickedCell[1]) {
                        for (let multiColIndex = Math.min(colIndex, this.lastClickedCell[0]); multiColIndex <= Math.max(colIndex, this.lastClickedCell[0]); multiColIndex++) {
                            this.selectedTableCellMatrix[rowIndex][multiColIndex] = selected;
                        }
                    } else {
                        for (let multiRowIndex = Math.min(rowIndex, this.lastClickedCell[1]); multiRowIndex <= Math.max(rowIndex, this.lastClickedCell[1]); multiRowIndex++) {
                            for (let multiColIndex = Math.min(colIndex, this.lastClickedCell[0]); multiColIndex <= Math.max(colIndex, this.lastClickedCell[0]); multiColIndex++) {
                                this.selectedTableCellMatrix[multiRowIndex][multiColIndex] = selected;
                            }
                        }
                    }
                    this.lastClickedCell = [colIndex, rowIndex];
                    return;
                } else if (event.ctrlKey || event.metaKey || this.$globalMethods.getDeviceType() !== 'desktop') {
                    this.selectedTableCellMatrix[rowIndex][colIndex] = !this.selectedTableCellMatrix[rowIndex][colIndex];
                    this.lastClickedCell = [colIndex, rowIndex];
                    return;
                } else {
                    this.clearSelectedTableCellMatrix(colIndex, rowIndex);
                    this.selectedTableCellMatrix[rowIndex][colIndex] = !this.selectedTableCellMatrix[rowIndex][colIndex];
                    this.lastClickedCell = [colIndex, rowIndex];
                    return;
                }
            },
            clearColumnsSelectedTableCellMatrix(exceptColIndex) {
                for (let rowIndex = 0; rowIndex < this.selectedTableCellMatrix.length; rowIndex++) {
                    for (let colIndex = 0; colIndex < this.selectedTableCellMatrix[rowIndex].length; colIndex++) {
                        if (colIndex == exceptColIndex) continue;
                        this.selectedTableCellMatrix[rowIndex][colIndex] = false;
                    }
                }
            },
            clearRowsSelectedTableCellMatrix(exceptRowIndex) {
                for (let rowIndex = 0; rowIndex < this.selectedTableCellMatrix.length; rowIndex++) {
                    for (let colIndex = 0; colIndex < this.selectedTableCellMatrix[rowIndex].length; colIndex++) {
                        if (rowIndex == exceptRowIndex) continue;
                        this.selectedTableCellMatrix[rowIndex][colIndex] = false;
                    }
                }
            },
            clearSelectedTableCellMatrix(x, y) {
                for (let rowIndex = 0; rowIndex < this.selectedTableCellMatrix.length; rowIndex++) {
                    for (let colIndex = 0; colIndex < this.selectedTableCellMatrix[rowIndex].length; colIndex++) {
                        if (x == colIndex && y == rowIndex) continue;
                        this.selectedTableCellMatrix[rowIndex][colIndex] = false;
                    }
                }
            },
            initSelectedTableCellMatrix() {
                const currentDate = this.currentSchedulePeriod.date;
                const currentYear = Number(currentDate.split("-")[0]);
                const currentMonth = Number(currentDate.split("-")[1]);

                const selectedTableCellMatrix = [];
                for (let index = 0; index < this.activeStaffs.length; index++) {
                    selectedTableCellMatrix.push([]);
                }
                
                for (const row of selectedTableCellMatrix) {
                    for (let index = 0; index < this.getAmountOfDaysInMonth(currentYear, currentMonth); index++) {
                        row.push(false);
                    }
                }
                this.selectedTableCellMatrix = selectedTableCellMatrix;
            },
            initScheduleMatrix() {
                const scheduleMatrix = [];
                for (const staff of this.activeStaffs) {
                    const currentSchedules = this.schedules.filter(schedule => schedule.staff.id == staff.id)
                    if (currentSchedules.length > 0) {
                        const currentSchedule = currentSchedules[0];
                        scheduleMatrix.push({id: currentSchedule.id, staff: staff.id, content: Object.values(currentSchedule.content)})
                    } else {
                        const currentDate = this.currentSchedulePeriod.date;
                        const currentYear = Number(currentDate.split("-")[0]);
                        const currentMonth = Number(currentDate.split("-")[1]);
                        scheduleMatrix.push({id: null, staff: staff.id,content: Array(this.getAmountOfDaysInMonth(currentYear, currentMonth)).fill("")});
                    }
                }
                
                this.scheduleMatrix = scheduleMatrix;
            },
            handleActivateSelectingWithMouseDown(event) {
                if (this.scheduleMode != "edit") return;
                if (this.$refs.scheduleSection.querySelector("table").contains(event.target)) {
                    const rowIndex = Number(event.target.getAttribute("data-y"));
                    const colIndex = Number(event.target.getAttribute("data-x"));
                    if (rowIndex >=0 && rowIndex < this.selectedTableCellMatrix.length && colIndex >= 0 && colIndex < this.selectedTableCellMatrix[rowIndex].length) {
                        this.isSelecting = true;
                        this.mouseMoveStart = [colIndex, rowIndex];
                    }
                }
            },
            handleDeactivateSelectingWithMouseUp() {
                if (this.scheduleMode != "edit") return;
                this.isSelecting = false;
            },
            handleSelectWithMouseMove(event) {
                if (this.scheduleMode != "edit") return;
                if (this.isSelecting && this.$refs.scheduleSection.querySelector("table").contains(event.target) && event.target.tagName == "TD") {
                    const rowIndex = Number(event.target.getAttribute("data-y"));
                    const colIndex = Number(event.target.getAttribute("data-x"));
                    if (rowIndex >=0 && rowIndex < this.selectedTableCellMatrix.length && colIndex >= 0 && colIndex < this.selectedTableCellMatrix[rowIndex].length) {
                        if (!(event.shiftKey || event.ctrlKey || event.metaKey || this.$globalMethods.getDeviceType() !== "desktop")) {
                            this.initSelectedTableCellMatrix();
                        }
                        for (let multiRowIndex = Math.min(rowIndex, this.mouseMoveStart[1]); multiRowIndex <= Math.max(rowIndex, this.mouseMoveStart[1]); multiRowIndex++) {
                            for (let multiColIndex = Math.min(colIndex, this.mouseMoveStart[0]); multiColIndex <= Math.max(colIndex, this.mouseMoveStart[0]); multiColIndex++) {
                                this.selectedTableCellMatrix[multiRowIndex][multiColIndex] = true;
                            }
                        }
                    }
                }
            },
            addHandleToSelectWithMouseMove() {
                document.body.addEventListener("mousedown", this.handleActivateSelectingWithMouseDown);
                document.body.addEventListener("mouseup", this.handleDeactivateSelectingWithMouseUp);
                document.body.addEventListener("mousemove", this.handleSelectWithMouseMove);
            },
            removeHandleToSelectWithMouseMove() {
                document.body.removeEventListener("mousedown", this.handleActivateSelectingWithMouseDown);
                document.body.removeEventListener("mouseup", this.handleDeactivateSelectingWithMouseUp);
                document.body.removeEventListener("mousemove", this.handleSelectWithMouseMove);
            },
            handleUnselectAllWithEsc(event) {
                if (event.key === "Escape") {
                    this.initSelectedTableCellMatrix();
                }
            },
            addHandleUnselectAllWithEsc() {
                document.body.addEventListener("keydown", this.handleUnselectAllWithEsc);
            },
            removeHandleUnselectAllWithEsc() {
                document.body.removeEventListener("keydown", this.handleUnselectAllWithEsc);
            },
            handleDeleteMarkWithBackspace(event) {
                if (event.key === "Delete" || event.key === "Backspace") {
                    this.markSelectedCell("");
                }
            },
            addHandleDeleteMarkWithBackspace() {
                document.body.addEventListener("keydown", this.handleDeleteMarkWithBackspace);
            },
            removeHandleDeleteMarkWithBackspace() {
                document.body.removeEventListener("keydown", this.handleDeleteMarkWithBackspace);
            },
            autoDropSelection(event) { 
                if (this.$refs.scheduleSection && !this.$refs.scheduleSection.contains(event.target)) {
                    this.initSelectedTableCellMatrix();
                }
            },
            addAutoDropSelection() {
                document.body.addEventListener("click", this.autoDropSelection)
            }, 
            removeAutoDropSelection() {
                document.body.removeEventListener("click", this.autoDropSelection);
            },
            initData() {
                this.initSelectedTableCellMatrix();
                this.initScheduleMatrix();
            }
        },
        created() {
            this.initData();
        },
        mounted() {
            this.addAutoDropSelection();
            this.addHandleDeleteMarkWithBackspace();
            this.addHandleUnselectAllWithEsc();
            this.addHandleToSelectWithMouseMove();
            this.addAutoCloseDayHourOptionBlock();
            this.addAutoCloseNightHourOptionBlock();
        },
        unmounted() {
            this.removeAutoDropSelection();
            this.removeHandleDeleteMarkWithBackspace();
            this.removeHandleUnselectAllWithEsc();
            this.removeHandleToSelectWithMouseMove();
            this.removeAutoCloseDayHourOptionBlock();
            this.removeAutoCloseNightHourOptionBlock();
        },
    }
</script>